<template>
  <div>
    <LayoutDash
      username="Supervisor"
      :on-date-change="fetchData"
      link-to-edit="/sup-dashboard/edit-profile"
    >
      <template slot="menuItems">
        <li v-for="{ title, icon, path } in menu" :key="title" class="nav-item">
          <MenuItems :menu-item="title" :icon-menu="icon" :to-where="path" />
        </li>
      </template>
      <template slot="infoCards">
        <div
          v-for="{ cardTitle, cardNumbers, cardMeta } in cardsInfo"
          :key="cardTitle"
          class="card"
        >
          <InfoCards
            :card-title="cardTitle"
            :card-numbers="cardNumbers"
            :card-meta="cardMeta"
          />
        </div>
      </template>
      <template slot="chartCards">
        <ChartCards
          :line-collection="salesVsMonths.chart"
          :dough-collection="salesVsCompanies.chart"
          :daugh-title="daughTitle"
        />
      </template>
    </LayoutDash>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LayoutDash from "../../components/LayoutDash";
import ChartCards from "../../components/ChartCards";
import InfoCards from "../../components/InfoCards";
import MenuItems from "../../components/MenuItems";
export default {
  name: "AdminDashboard",
  components: {
    LayoutDash,
    ChartCards,
    InfoCards,
    MenuItems,
  },
  data() {
    return {
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/supervisor",
        },
        {
          title: "Add Sales Agent",
          icon: "fa fa-plus",
          path: "/supervisor/agents/new",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/supervisor/sales",
        },
        {
          title: "Agents",
          icon: "fa fa-users",
          path: "/supervisor/agents",
        },
      ],
      cardsData: [
        {
          cardTitle: "Agents",
          cardNumbers: "--",
          cardMeta: "Total registered agents",
        },
        {
          cardTitle: "Total Sales",
          cardNumbers: "--",
          cardMeta: `-- more than lat month`,
        },
        {
          cardTitle: "Sales this Week",
          cardNumbers: "--",
          cardMeta: `-- more than last week`,
        },
        {
          cardTitle: "Drafts",
          cardNumbers: "--",
          cardMeta: "Total sales drafts",
        },
      ],
      daughTitle: `Agent's sales shares`,
    };
  },

  computed: {
    ...mapGetters({
      salesVsMonths: "stats/salesVsMonths",
      salesVsCompanies: "stats/salesVsCompanies",
      otherStats: "stats/otherStats",
    }),
    cardsInfo() {
      const cards = [...this.cardsData];
      if (this.otherStats.totalAgents)
        cards[0] = {
          cardTitle: "Agents",
          cardNumbers: this.otherStats.totalAgents.count,
          cardMeta: "Total registered agents",
        };
      if (this.otherStats.totalSales)
        cards[1] = {
          cardTitle: "Total Sales",
          cardNumbers: this.otherStats.totalSales.count,
          cardMeta: "Total sales during selected period of time",
        };

      if (this.otherStats.weeklySales)
        cards[2] = {
          cardTitle: "Sales this Week",
          cardNumbers: this.otherStats.weeklySales.count,
          cardMeta: `${this.isMoreOrLes(
            this.otherStats.weeklySales.count -
              this.otherStats.weeklySales.previous
          )} last week`,
        };
      if (this.otherStats.totalDrafts)
        cards[3] = {
          cardTitle: "Drafts",
          cardNumbers: this.otherStats.totalDrafts.count,
          cardMeta: "Total sales drafts",
        };
      return cards;
    },
  },
  watch: {
    $route: "fetchAllData",
  },
  created() {
    this.fetchAllData();
  },
  methods: {
    fetchAllData() {
      const { id: companyId } = this.$route.params;
      this.$store.dispatch("stats/fetchSalesVsMonths", { companyId });
      this.$store.dispatch("stats/fetchSalesVsCompanies", { companyId });
      this.$store.dispatch("stats/fetchOtherStats", { companyId });
      this.$store.dispatch("sales/fetchCompanySales");
    },
    isMoreOrLes(value) {
      if (value < 0) {
        return `${value * -1} less than`;
      }
      return `${value} more than`;
    },
    fetchData(range) {
      const { id: companyId } = this.$route.params;
      const { start, end } = range;
      this.$store.dispatch("stats/fetchSalesVsMonths", {
        start,
        end,
        companyId,
      });
      this.$store.dispatch("stats/fetchSalesVsCompanies", {
        start,
        end,
        companyId,
      });
      this.$store.dispatch("stats/fetchOtherStats", { start, end, companyId });
    },
  },
};
</script>
<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}
</style>
